import styled from 'styled-components';
import { Media } from 'assets/Mixins.style';

import { Container as CommonContainer } from 'assets/Common/Layout';

export const Wrapper = styled.div`
  display: block;
  width: 100%;
  padding: ${props => props.theme.padding.default};
  background: ${props => props.theme.background};

  ${Media.md`
    padding: ${props => props.theme.padding.md};
  `}
`;

export const Container = styled.div`
  ${CommonContainer}
`;

export const Text = styled.div`
  display: block;
  width: 100%;
  color: ${props => props.theme.color};
  font-family: ${props => props.theme.fontFamily};
  font-size: ${props => `${props.theme.fontSize.default}rem`};
  line-height: ${props => props.theme.lineHeight};
  font-weight: ${props => props.theme.fontWeight};
  text-align: ${props => props.theme.textAlign.default};
  cursor: default;

  ${Media.lg`
    font-size: ${props => `${props.theme.fontSize.lg}rem`};
  `}

  ${Media.md`
    font-size: ${props => `${props.theme.fontSize.md}rem`};
  `}

  ${Media.sm`
    font-size: ${props => `${props.theme.fontSize.sm}rem`};
    text-align: ${props => props.theme.textAlign.sm};
  `}

  a {
    color: ${props => props.theme.link.color};

      &:hover{
        color: ${props => props.theme.link.colorOnHover};
      }
  }
`;
